import { useCentralizedMe } from '@crehana/auth';

import { getTodayDate } from '../../utils';
import type { TimeEmployeeTrackerTeamListTeamLastActivityQuery } from './team-last-activity.v5.generated';
import { useTimeEmployeeTrackerTeamListTeamLastActivityQuery } from './team-last-activity.v5.generated';

type TResponse =
  TimeEmployeeTrackerTeamListTeamLastActivityQuery['time']['shift_assignments']['list_team_weekly_schedule_last_status'];

type TPayload = Extract<
  TResponse,
  { __typename?: 'TimeListTeamLastStatusPayload' }
>;

export type TTeamMember = TPayload['members'][number];

type TUseTeamLastActivityReturn = {
  data: TTeamMember[];
  totalCount: number;
  loading: boolean;
  error: boolean;
  refetch: () => void;
};

export const useTeamLastActivity = (): TUseTeamLastActivityReturn => {
  const { currentPageOrganization } = useCentralizedMe();

  const { data, loading, error, refetch } =
    useTimeEmployeeTrackerTeamListTeamLastActivityQuery({
      variables: {
        input: {
          centralized_organization_id: currentPageOrganization.id,
          date: getTodayDate(),
        },
      },
      context: { clientName: 'v5' },
      fetchPolicy: 'cache-and-network',
    });

  const response =
    data?.time?.shift_assignments?.list_team_weekly_schedule_last_status;
  const payload =
    response?.__typename === 'TimeListTeamLastStatusPayload'
      ? response
      : undefined;

  return {
    data: payload?.members ?? [],
    totalCount: payload?.total_count ?? 0,
    loading,
    error:
      !!error ||
      (!!response && response.__typename !== 'TimeListTeamLastStatusPayload'),
    refetch: () => {
      refetch();
    },
  };
};
